import { render } from "./LinkExistingDialog.vue?vue&type=template&id=56b45215&ts=true"
import script from "./LinkExistingDialog.vue?vue&type=script&lang=ts"
export * from "./LinkExistingDialog.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__